<template>
  <div>
    Coefficient between 0 and 1, the default value is 0.6.<br />
                    Used for solar radiation pressure.<br />
  </div>
</template>

<script>
export default {
  name: 'tooltipReflectionCoefficient'
}
</script>
